import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import * as UIC from '@dds-uicore/all';
import { AuthService } from '../shared/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../shared/services/common.service';
import { NavList } from '../shared/models/navlist.model';
import { NavService } from '../shared/services/nav.service';
import { GlobalConstants } from '../shared/global-constants';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, AfterViewInit {
  RoleName: any;
  Moderator = GlobalConstants.Moderator;
  Publisher = GlobalConstants.Publisher;
  navItems: NavList[] = [];
  mode: string = "default";
  parameters: any;
  displayedColumns: string[] = ['ArticleTitle'];
  public dataSource: any = [];
  public dataArray: any;
  public rowSize: number;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('searchText') searchText: ElementRef
  public rowsCount: number;
  processingLogin: boolean;
  constructor(private navService: NavService, private authService: AuthService, private route: ActivatedRoute,
  private commonService: CommonService, private router: Router) { }
  ht: any;
  loading: boolean = false;
  dataHeight: number;
  ngOnInit(): void {
    localStorage.removeItem('route');
    this.route.queryParams.subscribe((params: any) => {
      if (Object.keys(params).length) { //params like accessToken and expiresIn
        this.processingLogin=true;
      }
      else
        this.processingLogin=false;
    })
    this.loading = true;
    [].forEach.call(document.querySelectorAll("[data-toggle=\"dds__form-validation\"]"), function (element) {
      new UIC.Form(element, { validate: "true" });

    });
    if (localStorage.getItem('authToken')) {
      this.loadArticleSearchDetails()
    }
    else {
      this.commonService.gettoken('').subscribe(data => {
        console.log(data);
        this.authService.setAuthToken(data.authToken)
        this.loadArticleSearchDetails()
      });
    }
  }
  ngAfterViewInit(): void {
    document.getElementsByClassName('mat-paginator-range-label')[0]['title'] = 'Articles count';
  }
  loadArticleSearchDetails() {

    this.commonService.getSearchResults('*').subscribe(data => {

      if (data.Error.toLocaleLowerCase() == "null") {
        this.dataArray = data.data;
        this.dataSource = new MatTableDataSource<ArticlesList>(this.dataArray);
        this.dataSource.paginator = this.paginator;
        this.rowSize = this.dataSource.filteredData.length;
        this.loading = false;
        this.loadUserDetails();
              }
      else {
        this.dataSource = [];
        this.rowSize = 0;
        this.loading = false;
        this.loadUserDetails();
      };
      (error) => {
        this.commonService.setNotification("Something went wrong! Please try again after some time.", "Error");
        this.loading = false;
        this.router.navigate(['/'])
        return;
      }

    });
  }

  loadUserDetails() {
    this.route.queryParams.subscribe((params: any) => {
      if (Object.keys(params).length) { //params like accessToken and expiresIn
        this.parameters = params;
        this.authService.setSession(this.parameters);
        this.commonService.fetchUserDetails();
      }
    })
  }
  loadNavDetails() {
    this.authService.itemValue.subscribe((nextValue) => {
      this.RoleName = nextValue.RoleName;
      this.commonService.getNavList();

    })
  }
  applyFilter() {
    this.loading = true;
    if (this.searchText.nativeElement.value != '' && this.searchText.nativeElement.value != undefined) {
      this.commonService.getSearchResults(this.searchText.nativeElement.value).subscribe(data => {
        if (data.Error.toLocaleLowerCase() != "null") {
          this.dataSource = [];
          this.rowSize = 0;
          this.loading = false;

        }
        else {
          this.dataSource = new MatTableDataSource<ArticlesList>(data.data);
          this.dataSource.paginator = this.paginator;

          this.dataSource.filteredData = this.dataArray;
          this.rowSize = this.dataSource.filteredData.length;
          this.loading = false;
          setTimeout(() => {
            this.dataHeight = document.getElementById('dtCIO').scrollHeight + (document.getElementsByClassName('mat-paginator')[0].scrollHeight * 2.4);
          }, 100);
        };
        (error) => {
          this.commonService.setNotification("Something went wrong! Please try again after some time.", "Error");
          this.loading = false;
          this.router.navigate(['/'])
          return;
        }
      });

    }
    else {
      this.loadArticleSearchDetails();


    }

  }
}
export interface ArticlesList {

  ArticleId: number;
  ArticleTitle: string;
  FileType: string;
}
